import { Button } from '@piggytechng/component-library';
import { useState } from 'react';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';

import { OverideButtonStyle } from '../../helpers/utils';

const SettingsUserSecurity = () => {
  const [inputType, setInputType] = useState('password');
  return (
    <div className="settings-section">
      <span className="settings-section-title">Change Password</span>
      <br />
      <div className="settings-form">
        <div className="settings-form-item password">
          <label htmlFor="current-password">Current Password</label>
          <input className="input" placeholder="Current Password" type={inputType} />
          <button
            onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')}
            className="password-toggle"
          >
            {inputType === 'password' ? <IoMdEye /> : <IoMdEyeOff />}
          </button>
        </div>

        <div className="settings-form-item password">
          <label htmlFor="new-password">New Password</label>
          <input className="input" placeholder="New Password" type={inputType} />
          <button
            onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')}
            className="password-toggle"
          >
            {inputType === 'password' ? <IoMdEye /> : <IoMdEyeOff />}
          </button>
        </div>
        <div className="settings-form-item password">
          <label htmlFor="confirm-password">Confirm New Password</label>
          <input className="input" placeholder="Confirm New Password" type={inputType} />
          <button
            onClick={() => setInputType(inputType === 'password' ? 'text' : 'password')}
            className="password-toggle"
          >
            {inputType === 'password' ? <IoMdEye /> : <IoMdEyeOff />}
          </button>
        </div>

        <div className="settings-form-action">
          <Button {...OverideButtonStyle} style={{ width: '250px' }}>
            Change Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SettingsUserSecurity;
